<script setup>
  import {ref} from "vue";

  import ComponentIcon from "@components/Icons/Icon.vue";
  import ComponentTableHeadCheckbox from "@components/Table/TableHeadCheckbox.vue";

  defineOptions({
    name: "PatientsExternalPatientHead",
  });

  const props = defineProps({
    modelValue: {
      type: String,
      default: "",
    },
    availableRows: {
      type: Array,
      required: true,
    },
    selectedRows: {
      type: Array,
      required: true,
    },
  });

  const emit = defineEmits(["update:modelValue", "update:selectedRows"]);

  const order = ref(props.modelValue || "");

  // TODO - outsource in file to reduce double code
  function orderBy(by) {
    if (order.value.includes(by)) {
      // already sorted by this colum, so flip direction
      if (by.slice(0, 1) === "-") {
        // asc
        order.value = by.slice(1); // remove "-"
      } else {
        // desc
        order.value = "-" + by; // add "-"
      }
    } else {
      // not already sorted by this column, asc is default
      order.value = by;
    }
    emit("update:modelValue", order.value);
  }
</script>

<template>
  <tr class="border-b-2 border-gray-400 leading-tight" :data-test="getTestId('external-head')">
    <!-- ☑️ multi-select & patient -->
    <th class="px-0.5 py-2 text-left align-top font-normal">
      <div class="flex items-center space-x-2">
        <ComponentTableHeadCheckbox
          v-if="$page.props?.can?.allow_multi_select"
          :available-rows="availableRows"
          :selected-rows="selectedRows"
          :test-id="getTestId('external-head')"
          @update:selected-rows="(newSelectedRows) => $emit('update:selectedRows', newSelectedRows)"
        />
        <span>Patient</span>
      </div>
      <div class="text-xs" :class="{'ml-8': $page.props?.can?.allow_multi_select}">Geburtsdatum Alias</div>
    </th>

    <th class="px-0.5 py-2 text-left align-top font-normal">
      <div>Herkunft</div>
    </th>

    <th class="px-0.5 py-2 text-left align-top font-normal">Information</th>
    <th class="px-0.5 py-2 text-left align-top font-normal">Offene Aufgaben</th>

    <th class="px-0.5 py-2 text-left align-top font-normal">
      <div>
        <button
          class="flex items-center space-x-2 text-left"
          :data-test="getTestId('external-head-sort-by-updated-at')"
          @click.prevent="orderBy('-updated_at')"
        >
          <span>Geändert</span>
          <ComponentIcon v-if="!order.includes('updated_at')">unfold_more</ComponentIcon>
          <ComponentIcon v-if="order === 'updated_at'">expand_less</ComponentIcon>
          <ComponentIcon v-if="order === '-updated_at'">expand_more</ComponentIcon>
        </button>
      </div>

      <div class="text-xs">Bearbeiter</div>
    </th>

    <th class="w-14">
      <!-- Aktionen -->
    </th>
  </tr>
</template>
